import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { createContext, useContext, useState } from "react";
import { saveLogInfo } from "api/Log.api";

export const NetworkContext = createContext({
    isOnNetworking: false,
    setIsOnNetworking: (status: boolean) => { },
});

export const NetworkProvider = ({ children }: { children: React.ReactNode }) => {
    const [isOnNetworking, setIsOnNetworking] = useState(false);
    const location = useLocation();

    useEffect(() => {
        console.log("=========================================");
        console.log("Layout.container::useEffect");
        console.log("useEffect", location);

        const sendLogToAPI = async (fullPath: string) => {
            console.log("sendLogToAPI", fullPath);
            try {
                await saveLogInfo({ uri: fullPath });
            } catch (error) {
                console.error("Failed to log path change:", error);
            }
        };

        const fullPath = location.pathname + location.search; // 경로 + 쿼리 스트링
        const debounce = setTimeout(() => {
            sendLogToAPI(fullPath);
        }, 300); // 디바운스 설정 (300ms)

        console.log("=========================================");
        return () => clearTimeout(debounce); // 이전 타이머 클리어
    }, [location]); // 쿼리 스트링도 의존성에 추가

    return (
        <NetworkContext.Provider value={{ isOnNetworking, setIsOnNetworking }}>
            {children}
        </NetworkContext.Provider>
    );
};

export const useNetwork = () => useContext(NetworkContext);